'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIs = require('react-is');

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentPropType = function componentPropType(props, propName, componentName) {
  var value = props[propName];
  if (value == null || (0, _reactIs.isValidElementType)(value)) return null;
  return new Error(componentName + ': Invalid ' + propName + ' value. Expected a component.');
};

exports.default = (0, _createChainablePropType2.default)(componentPropType, 'component');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/utils/propTypes/component.js
// module id = 17
// module chunks = 3 4 5